export const searchParams = {
  INVITED_CHECK: 'isInvited',
};
